import { supabase } from './supabaseClient';

// ── FEAT-6: Trial-expiring email trigger ──────────────────────────
// Sends trial-expiring email once per calendar day when <= 3 days remain.
// Deduplication via localStorage key quipus_trial_warn_YYYY-MM-DD.
//
// Fix 2026-09-22 (tq82): antes vivía en UserRoleContext.tsx y se llamaba
// con profiles.trial_ends_at/is_paid — un reloj separado y desincronizado
// del que ya usan el banner y el gate de trial (subscriptions.trial_ends_at
// /status, migrados en tq81). Movida acá; ahora se llama desde
// CompanyContext.tsx justo donde se resuelve `subscription` — la MISMA
// fuente que usan isTrialExpired/daysRemaining, no una copia separada.
export async function maybeFireTrialExpiringEmail(
  trialEndsAt: Date,
  isPaid: boolean,
): Promise<void> {
  if (isPaid) return;
  const daysLeft = Math.ceil(
    (trialEndsAt.getTime() - Date.now()) / (24 * 60 * 60 * 1000),
  );
  if (daysLeft < 0 || daysLeft > 3) return;

  const todayKey = `quipus_trial_warn_${new Date().toISOString().slice(0, 10)}`;
  if (localStorage.getItem(todayKey)) return; // already sent today

  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.access_token || !session?.user?.email) return;

    const nombre = session.user.email.split('@')[0];
    const fecha_vencimiento = trialEndsAt.toLocaleDateString('es-PE', {
      day: 'numeric', month: 'long', year: 'numeric',
    });
    const waNumber = (import.meta.env.VITE_WHATSAPP_NUMBER as string | undefined) ?? '51999999999';
    const baseUrl  = window.location.origin;

    const res = await fetch('/api/send-email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${session.access_token}`,
      },
      body: JSON.stringify({
        to:       session.user.email,
        subject:  'Tu período de prueba vence pronto — TryQuiPus',
        template: 'trial-expiring',
        variables: {
          nombre,
          fecha_vencimiento,
          dashboard_url:    baseUrl,
          whatsapp_number:  waNumber,
          unsubscribe_url:  `${baseUrl}/politica-privacidad`,
          privacy_url:      `${baseUrl}/politica-privacidad`,
        },
      }),
    });
    if (res.ok) localStorage.setItem(todayKey, '1');
  } catch {
    // fire-and-forget — never block login flow
  }
}
